// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1L3mm","name":"ConsentHeader_name__3t0q7","birthday":"ConsentHeader_birthday__1fuZ2","skeleton":"ConsentHeader_skeleton__2IYKq"};